import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import ProfileTab from '../../Components/Profile/ProfileTabs';
import StripeForm from '../../Components/Stripe/StripeForm';
import { GetAllCategories } from '../../Redux/Auth/Auth_Action';
import { showLoader } from '../../Redux/services/Loader';
import stripe from '../../assets/images/stripe.png';
import cash_app from '../../assets/images/cashapp.png';
import paypal from '../../assets/images/paypal.png';
import venmo from '../../assets/images/venmo.png';
import Venmo from '../../Components/Venmo/Venmo';
import PayPalView from '../../Components/PayPal/PayPalView';
// import CashAppSubs from './CashAppSubs';


const Payment = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    let navigate = useNavigate();
    const [interests, setInterests] = useState({ interestsData: [] });
    const [postInterests, setPostInterests] = useState([]);
    const [paymentComp, setPaymentComp] = useState(null);
    const reduxUserActvPckg = useSelector((state) => state.Auth);

    const IntrestFunction = () => {
        dispatch(GetAllCategories())
            .then((res) => {
                setInterests({ ...interests, interestsData: res.data.response.data.data });
                showLoader("none");
            })
            .catch((e) => {
                console.log(e);
                showLoader("none");
                toast.error("Network Error");
            })
    }

    const SelectItem = (id) => {
        let limit = location.state.limit_intrst;
        if (postInterests.length == limit || postInterests.length > limit) {
            toast.error(`can select only ${limit} packages`)
            setPostInterests([]);
        } else {
            if (postInterests?.includes(id) === false) {
                setPostInterests((oldVal) => {
                    return [...oldVal, id];
                });
            } else {
                setPostInterests((oldVal) => {
                    let filtarr = postInterests?.filter((item, index) => {
                        return item !== id;
                    })
                    return [...filtarr];
                })
            }
        }
    }

    const [tok, setTok] = useState();
    const handleChange = (e) => {
        setTok(e);
    }

    useEffect(() => {
        if (!reduxUserActvPckg?.slug) {
            IntrestFunction();
            window.scroll(0, 0);
        } else {
            navigate('/subscription');
        }
    }, []);


    return (
        <div>
            <section className='profile my_subscription'>
                <Header />
                <div className='container px-4'>
                    <div className='row'>
                        <div className='col-lg-12 text-center'>
                            <p className='f-pop-bold f-43 mb-5 mt-3'>Package Details</p>
                        </div>
                        {/* <div className='col-lg-4'>
                            <ProfileTab />
                        </div> */}

                        <div className='payment_component'>

                        </div>

                        <div className='col-lg-12 mb-5 res-pxx'>
                            <div className='row'>
                                <div className='col-lg-12'>
                                    <p className='f-pop-bold f-30 mb-4'>
                                        Select {location?.state?.limit_intrst} Interests <small className='f-14'>(Selected Interests can not be editable *)</small>
                                    </p>
                                </div>
                                <div className='col-lg-6'>

                                    {interests?.interestsData.map((item, index) => {
                                        return (
                                            <div key={index} className='intrest_div my-3'>
                                                <span
                                                    className='clr-e0 f-mon-bold'>{item?.title}</span>
                                                <input
                                                    type="checkbox"
                                                    checked={postInterests.includes(item?.id)}
                                                    onChange={selected => SelectItem(item.id)}
                                                    className='mt-1 ml-3' />
                                            </div>
                                        )
                                    })}

                                </div>
                                <div className='col-lg-12'>
                                    <p className='f-pop-bold f-30 mb-4'>Payment Information</p>
                                    {/* <p className='f-mon-semibold f-20 mb-4 mt-4'></p> */}
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>
                                        Package Title
                                        <span className='mx-2'></span>
                                        :
                                        <span className='mx-2'></span>
                                        <span className='f-mon-bold clr-e0'>{location?.state?.title}</span>
                                    </p>
                                    <p className='f-mon-semibold f-20 mb-4 mt-4'>
                                        Package Price
                                        <span className='mx-2'></span>
                                        :
                                        <span className='mx-2'></span>
                                        <span className='clr-e0 f-mon-bold clr-e0'>$ {location?.state?.price}</span>
                                    </p>
                                </div>
                                {reduxUserActvPckg?.activePackage
                                    ?
                                    <>
                                        <div className='col-lg-12'>
                                            <p class="f-pop-bold f-30 mb-4">You have already subscribed!</p>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className='col-lg-12'>
                                            <p className='f-pop-bold f-30 mb-4'>Payment Method</p>
                                            <div className='row'>
                                                <div className='col-md-3'>
                                                    <img src={stripe} onClick={() => { setPaymentComp("stripe") }} className={paymentComp === "stripe" ? "bt_payment_image selected_btn" : "bt_payment_image"} />
                                                </div>
                                                {/* <div className='col-md-3'>
                                                    <img src={paypal} onClick={() => { setPaymentComp("paypal") }} className={paymentComp === "paypal" ? "bt_payment_image selected_btn" : "bt_payment_image"} />
                                                </div>
                                                <div className='col-md-3'>
                                                    <img onClick={() => { setPaymentComp("venmo") }} src={venmo} className={paymentComp === "venmo" ? "bt_payment_image selected_btn" : "bt_payment_image"} />
                                                </div> */}
                                                {/* <div className='col-md-3'>
                                                    <img onClick={() => { setPaymentComp("cash-app") }} src={cash_app} className={paymentComp === "cash-app" ? "bt_payment_image selected_btn" : "bt_payment_image"} />
                                                </div> */}
                                            </div>
                                        </div>
                                        <div className='col-lg-12 mt-4'>

                                            {paymentComp === "stripe"
                                                &&
                                                <StripeForm
                                                    handleSet={{ price: location?.state?.price, slug: location?.state?.slug, interestsData: postInterests }}

                                                />
                                            }
                                            {/* {paymentComp === "venmo"
                                                &&
                                                <Venmo props={{ price: location?.state?.price, slug: location?.state?.slug, interestsData: postInterests }} />
                                            }
                                            {paymentComp === "paypal"
                                                &&
                                                <PayPalView props={{ price: location?.state?.price, slug: location?.state?.slug, interestsData: postInterests, href: "checkoutPage" }} />
                                            } */}
                                            {/* {paymentComp === "cash-app"
                                                &&
                                                <CashAppSubs props={{ price: location?.state?.price, slug: location?.state?.slug, interestsData: postInterests }} />
                                            } */}
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Payment;